import { useOrganisationsContext } from '@/context/OrganisationsContext';
import { useSubscriptionContext } from '@/context/SubscriptionContext';
import { useTakenTeamSeats } from '@/hooks/useTakenTeamSeats';

export const useSubscriptionTeamSeats = ({
    isTeamCreated,
}: {
    isTeamCreated: boolean;
}) => {
    const { currentOrganisationSubscriptionPlan } = useSubscriptionContext();
    const { members } = useOrganisationsContext();
    const { takenSeats } = useTakenTeamSeats();

    const currentPlanSeats = currentOrganisationSubscriptionPlan?.seats || 0;
    const unusedSeats = currentPlanSeats - takenSeats;
    const pendingInvitationsCount = takenSeats - (members?.length || 0);

    const hasReachedSeatsLimit = unusedSeats <= 0;
    const canInviteMembers = isTeamCreated ? unusedSeats > 0 : false;

    return {
        currentPlanSeats,
        takenSeats,
        unusedSeats,
        pendingInvitationsCount,
        hasReachedSeatsLimit,
        canInviteMembers,
        members,
    };
};
